"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'email.payment.success.subject': 'Płatność pomyślna - Subskrypcja potwierdzona',
    'email.payment.success.title': 'Płatność została pomyślnie przetworzona!',
    'email.payment.success.text': 'Dziękujemy za płatność. Twoja subskrypcja została potwierdzona i jest teraz aktywna.',
    'email.payment.success.confirmation': 'Wkrótce otrzymasz rachunek za tę płatność.',
    'email.payment.success.footer': 'Jeśli masz pytania, skontaktuj się z naszym zespołem wsparcia.',
    'email.payment.failed.subject': 'Płatność nieudana - Wymagane działanie',
    'email.payment.failed.title': 'Przetwarzanie płatności nie powiodło się',
    'email.payment.failed.text': 'Nie mogliśmy przetworzyć Twojej płatności za subskrypcję. Zaktualizuj swoją metodę płatności, aby kontynuować korzystanie z naszych usług.',
    'email.payment.failed.retry_text': 'Aby uniknąć przerwy w usłudze, spróbuj ponownie jak najszybciej.',
    'email.payment.failed.retry_button': 'Spróbuj ponownie',
    'email.payment.failed.support_button': 'Skontaktuj się z pomocą',
    'email.payment.failed.footer': 'Jeśli nadal masz problemy, skontaktuj się z naszym zespołem wsparcia.',
    'email.payment.plan': 'Plan subskrypcji',
    'email.payment.amount': 'Kwota',
    'email.payment.next_billing': 'Data następnej płatności',
    'email.payment.failure_reason': 'Powód niepowodzenia',
    'email.payment.dashboard_button': 'Zobacz panel',
    'email.payment.download_invoice': 'Pobierz fakturę',
};
